import React from 'react'

/**
 * 格式化 textarea 的文本内容
 * 将 \n 转换成 <p>
 * params
 *   content: 待格式化的内容
 *   Tag: 输出的标签
 * */
export const simpleFormat = (content, Tag = 'p') => {
  if (!content) return content
  if (typeof content === 'object') return content
  return (
    (content || '').split("\n").map((item, key) => {
      return <Tag key={key}>{item.replace(/ /g, '\u00A0') }</Tag>;
    })
  )
}


// WEBPACK FOOTER //
// ./app/javascript/lib/util.js